import { AxiosInstance } from 'axios';

import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { editorsPick, editorsPickParams } from './editorsPick.types';

const getEditorsPickList = (client: AxiosInstance) => async (params: editorsPickParams) => {
  return (await client.get<PaginatedApiResponse<editorsPick[]>>(API_ROUTES.GET_EDITORS_PICK, { params })).data;
};
const getEditorDetail = (client: AxiosInstance) => async (params: editorsPickParams) => {
  return (await client.get<PaginatedApiResponse<editorsPick[]>>(API_ROUTES.GET_EDITORS_PICK, { params })).data;
};
export const editorsPickQueries = {
  all: () => ['editors-pick'],
  list: (params: editorsPickParams) =>
    queryFactoryOptions<PaginatedApiResponse<editorsPick[]>>({
      queryKey: [...editorsPickQueries.all(), 'list', params],
      queryFn: (client) => () => getEditorsPickList(client)(params),
    }),
  detail: (editorPickId: string) =>
    queryFactoryOptions<PaginatedApiResponse<editorsPick[]>>({
      queryKey: [...editorsPickQueries.all(), 'detail', editorPickId],
      queryFn: (client: AxiosInstance) => () => getEditorDetail(client)({ editorPickId }),
    }),
};
